import React, { useState, useEffect } from "react";
import { FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Collapse,
  IconButton,
  TextField,
  Typography,
  useMediaQuery,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp, Edit, Delete } from "@mui/icons-material";
import api from "../../Services/api";
import { downloadSmartTalksCsv } from "../../Services/exportSmartTalks";
import { currentConfig } from "../../Services/config";
import Sidebar from '../Sidebar';
import '../Home/home.css';

export const Home = () => {
  const navigate = useNavigate();
  const [sidebar, setSidebar] = useState(false);
  const [listemail, setlistemail] = useState([]);
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [situacao] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [expandedRow, setExpandedRow] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(null);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [atividadeFilter, setAtividadeFilter] = useState(false);

  // Adicionando states para filtro de data
  const getCurrentMonthRange = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return { firstDay, lastDay };
  };

  const { firstDay, lastDay } = getCurrentMonthRange();
  const [dataInicio, setDataInicio] = useState(firstDay.toISOString().split('T')[0]);
  const [dataFim, setDataFim] = useState(lastDay.toISOString().split('T')[0]);

  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    ValidaUsuario();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    filterEmails();
    // eslint-disable-next-line
  }, [searchTerm, listemail, atividadeFilter, dataInicio, dataFim]);

  const filterEmails = () => {  
    setFilteredEmails(
      listemail.filter((email) => {
        const emailDate = new Date(email.data_cadastro);
        const startDate = new Date(dataInicio);
        const endDate = new Date(dataFim);
        const matchesSearch =
          email.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
          email.cpf.includes(searchTerm) ||
          email.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          email.telefone.includes(searchTerm);
        const matchesAtividade = !atividadeFilter || email.atividade === '1';
        return (
          matchesSearch &&
          emailDate >= startDate && emailDate <= endDate &&
          matchesAtividade
        );
      })
    );
  };

  async function ValidaUsuario() {
    api.defaults.headers.post = { 'Content-Type': 'application/json' };
    api.defaults.headers.common = { 'x-access-token': localStorage.getItem("token") };

    let usuario = await buscaUsuario();

    if (usuario.data[0] != null) {
      setlistemail(usuario.data);
      setFilteredEmails(usuario.data);
    }
  }

  async function buscaUsuario() {
    let response = await api.get('/pessoa/' + situacao);
    return response;
  }

  const editar = (value) => {
    navigate('/AlterarCadastro', { state: value });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const toggleExpand = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const handleDateChange = (event) => {
    const { name, value } = event.target;
    if (name === "dataInicio") {
      setDataInicio(value);
    } else {
      setDataFim(value);
    }
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    
    // Data do relatório
    doc.setFontSize(14);
    doc.text(`Data: ${new Date().toLocaleDateString('pt-BR')}`, 14, 20);
    doc.text(`Período: ${new Date(dataInicio).toLocaleDateString('pt-BR')} a ${new Date(dataFim).toLocaleDateString('pt-BR')}`, 14, 28);
    
    // Preparar dados da tabela
    const tableData = filteredEmails.map((email) => [
      email.nome,
      email.cpf,
      email.telefone || '-',
      `${email.cidade || ''} - ${email.estado || ''}`.replace(' - ', email.cidade && email.estado ? ' - ' : '').replace(/^- |^$/, email.cidade || email.estado || '-'),
      email.comoConheceu || '-',
      new Date(email.data_cadastro).toLocaleDateString('pt-BR')
    ]);
    
    // Configuração da tabela
    autoTable(doc, {
      head: [['Nome', 'CPF', 'Telefone', 'Localidade', 'Como Conheceu', 'Entrada']],
      body: tableData,
      startY: 35,
      styles: {
        fontSize: 8,
        cellPadding: 2,
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: 'bold'
      },
      columnStyles: {
        0: { cellWidth: 40 },
        1: { cellWidth: 30 },
        2: { cellWidth: 25 },
        3: { cellWidth: 35 },
        4: { cellWidth: 35 },
        5: { cellWidth: 20 }
      }
    });
    
    // Salvar o PDF
    doc.save(`relatorio-aguardando-envio-${new Date().toISOString().split('T')[0]}.pdf`);
  };



  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('pt-BR', options);
  };

  const formatQuestion = (value) => {
    return Number(value) === 1 ? "Sim" : "Não";
  };

  const deleteCadastro = (value) => {
    setSelectedId(value.id);
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
    setSelectedId(null);
  }

  const handleConfirmDelete = () => {
    if (selectedId) {
      DeletePessoa(selectedId);
    }
    handleClose();
  }

  async function DeletePessoa(id) {
    let delpessoa = await dellPessoa(id);

    if (delpessoa.status === 200) {
      alert('Cadastro removido com sucesso!');
      window.location.reload(false);
    } else {
      alert('Falha ao remover cadastro');
    }
  }

  async function dellPessoa(id) {
    let response = await api.delete('/pessoa/delete/' + id);
    return response;
  }

  async function EnviaEmail() {
    setLoading(true);

    api.defaults.headers.post = { 'Content-Type': 'application/json' };
    api.defaults.headers.post = { "Content-Type": 'multipart/form-data' };
    api.defaults.headers.common = { 'x-access-token': localStorage.getItem("token") };

    let response = await api.post('/send', { 'situacao': situacao });

    if (response.status === 200) {
      alert('Email enviado com sucesso!');
      window.location.reload();
    } else {
      alert('Falha ao enviar email');
    }
    setLoading(false);
  }

  const handleDownloadFile = async () => {
    setLoadingDownload(true);
    
    try {
      api.defaults.headers.common = { 'x-access-token': localStorage.getItem("token") };

      const params = new URLSearchParams();
      if (dataInicio) params.append('dataInicio', dataInicio);
      if (dataFim) params.append('dataFim', dataFim);
      params.append('situacao', '0');

      const response = await api.get(`/download-arquivo/?${params.toString()}`, {
        responseType: 'blob'
      });

      // Criar link temporário para download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Extrair nome do arquivo do header ou usar nome padrão
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'arquivo.xlsx';
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
        if (fileNameMatch) {
          fileName = fileNameMatch[1];
        }
      } else {
        fileName = `arquivo-aguardando-envio-${new Date().toISOString().split('T')[0]}.xlsx`;
      }
      
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      alert('Erro ao baixar arquivo');
    } finally {
      setLoadingDownload(false);
    }
  };

  return (
    <div className="home-container">
      <div className="home-header">
        <FaBars className="menu-icon" onClick={() => setSidebar(true)} />
        <Sidebar active={sidebar} setActive={setSidebar} />
        <Button
          variant="contained"
          color="primary"
          onClick={EnviaEmail}
          disabled={loading}
          style={{ marginLeft: 'auto', marginRight: '10px' }}
        >
          {loading ? <CircularProgress size={24} /> : 'Enviar Email'}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleDownloadFile}
          disabled={loadingDownload}
          style={{ marginRight: '10px' }}
        >
          {loadingDownload ? <CircularProgress size={24} /> : 'Baixar Arquivo'}
        </Button>
        {currentConfig.showSmartTalksExport && (
          <Button
            variant="contained"
            color="success"
            onClick={() => downloadSmartTalksCsv(filteredEmails, 'smart-talks-aguardando-envio')}
            disabled={filteredEmails.length === 0}
            style={{ marginRight: '10px' }}
          >
            Smart Talks
          </Button>
        )}
        <Button
          variant="outlined"
          color="primary"
          onClick={generatePDF}
        >
          Imprimir PDF
        </Button>
      </div>
      
      <div className="home-list">
        <legend>
            <Typography variant="h4">Aguardando Envio</Typography>
        </legend>
        <div className="search-container">
          <TextField
            label="Data Início"
            type="date"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={dataInicio}
            onChange={handleDateChange}
            name="dataInicio"
            margin="normal"
            style={{ marginRight: isMobile ? 0 : 10 }}
          />
          <TextField
            label="Data Fim"
            type="date"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={dataFim}
            onChange={handleDateChange}
            name="dataFim"
            margin="normal"
            style={{ marginRight: isMobile ? 0 : 10 }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={atividadeFilter}
                onChange={(e) => setAtividadeFilter(e.target.checked)}
                color="primary"
              />
            }
            label="Somente quem participou de atividade"
            style={{ marginLeft: 8, marginTop: 20}}
          />
          <TextField
            label="Buscar"
            variant="outlined"
            fullWidth
            margin="normal"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ padding: '5px' }} />
                <TableCell style={{ padding: '5px' }}>Nome</TableCell>
                <TableCell style={{ padding: '5px' }}>CPF</TableCell>
                {!isMobile && <TableCell style={{ padding: '5px' }}>Telefone</TableCell>}
                <TableCell style={{ padding: '5px' }}>Localidade</TableCell>
                <TableCell style={{ padding: '5px' }}>Entrada</TableCell>
                <TableCell style={{ padding: '5px' }}>Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredEmails.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      Nenhum registro encontrado
                    </TableCell>
                  </TableRow>
                ) : (
                filteredEmails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((email) => (
                  <React.Fragment key={email.id}>
                    <TableRow className="home-list-item">
                      <TableCell style={{ padding: '5px' }}>
                        <IconButton onClick={() => toggleExpand(email.id)}>
                          {expandedRow === email.id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                        </IconButton>
                      </TableCell>
                      <TableCell className="item-info" style={{ padding: '5px' }}>{email.nome}</TableCell>
                      <TableCell style={{ padding: '5px' }}>{email.cpf}</TableCell>
                      {!isMobile && <TableCell style={{ padding: '5px' }}>{email.telefone}</TableCell>}
                      <TableCell style={{ padding: '5px' }}>
                        {`${email.cidade || ''} - ${email.estado || ''}`.replace(' - ', email.cidade && email.estado ? ' - ' : '').replace(/^- |^$/, email.cidade || email.estado || '-')}
                      </TableCell>
                      <TableCell style={{ padding: '5px' }}>
                        {new Date(email.data_cadastro).toLocaleDateString('pt-BR')}
                      </TableCell>
                      <TableCell className="item-actions" style={{ padding: '5px' }}>
                        <IconButton onClick={() => editar(email)} className="action-button">
                          <Edit />
                        </IconButton>
                        <IconButton className="action-button" onClick={() => deleteCadastro(email)}>
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                        <Collapse in={Boolean(expandedRow === email.id)} timeout="auto" unmountOnExit>
                          <Box margin={1} padding={2} border={1} borderRadius={2} borderColor="grey.300">
                            <Typography variant="h6" gutterBottom style={{ fontSize: '1rem', fontWeight: 'bold' }}>
                              Informações Adicionais
                            </Typography>

                            {!isMobile && email.telefone && (
                              <Typography style={{ fontSize: '0.9rem', fontWeight: 'bold', marginTop: 8 }}>
                                📞 Telefone: <span style={{ fontWeight: 'normal' }}>{email.telefone}</span>
                              </Typography>
                            )}

                            {email.data_cadastro && (
                              <Typography style={{ fontSize: '0.9rem', fontWeight: 'bold', marginTop: 8, marginBottom: 30 }}>
                                📅 Entrada: <span style={{ fontWeight: 'normal' }}>{formatDate(email.data_cadastro)}</span>
                              </Typography>
                            )}

                            {email.pergunta1 !== null ? (
                              <Typography variant="h6" gutterBottom style={{ fontSize: '1rem', fontWeight: 'bold', marginTop: 16 }}>
                                Questionário de Saúde
                              </Typography>
                            ) : null}

                            {[
                              { label: 'Problemas cardíacos', value: email.pergunta1 },
                              { label: 'Gestante', value: email.pergunta2 },
                              { label: 'Dificuldades respiratórias ou asma', value: email.pergunta3 },
                              { label: 'Desmaios, epilepsia e/ou convulsões', value: email.pergunta4 },
                              { label: 'Em período pós-operatório', value: email.pergunta5 },
                              { label: 'Problemas ósseos e/ou na coluna vertebral', value: email.pergunta6 },
                              { label: 'Sob efeito de álcool e/ou entorpecentes', value: email.pergunta7 },
                              { label: 'Fobia de altura', value: email.pergunta8 },
                            ].map(
                              (item, index) =>
                                item.value !== null && (
                                  <Typography key={index} style={{ fontSize: '0.9rem', marginTop: 8 }}>
                                    <strong>❓ {item.label}:</strong>{' '}
                                    <span
                                      style={{
                                        fontWeight: item.value === 1 ? 'bold' : 'normal',
                                        color: item.value === 1 ? 'red' : 'inherit',
                                      }}
                                    >
                                      {formatQuestion(item.value)}
                                    </span>
                                  </Typography>
                                )
                            )}
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredEmails.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Linhas por página"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
        />
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmar Exclusão"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Tem certeza que deseja excluir este cadastro?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}